import { SupplierUser } from '@arpada/arp-lib-common-qupro';

export class SupplierExtendedData {
    public supplier: SupplierUser;
}
